import axios from 'axios';
import pathfinder from '@fiverr-private/pathfinder';
import { getContext } from '@fiverr-private/fiverr_context';
import { logger } from '@fiverr-private/obs';
import { ResourceType } from '../../../../../shared/types/resourceType';
import { fetchItems } from '../items';

export const fetchGigs = (lastItemId) => fetchItems(ResourceType.GIG, lastItemId);

export const gigsBySeller = async (sellerId) => {
    const { userId } = getContext();

    const url = pathfinder('collection_page_gigs_by_seller', { seller_id: sellerId });

    try {
        const { data } = await axios.get(url);

        return data.gigs;
    } catch (error) {
        logger.error(error, {
            description: 'Failed to get gigs by seller',
            sellerId,
            userId,
        });

        throw error;
    }
};
